import config from "../../config";

const getAccountId = () => {
    const user = JSON.parse(localStorage.getItem("user") || "{}");
    return user.accountId;
};

const buildUrl = (path, params = {}) => {
    const filtered = Object.fromEntries(
        Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== "")
    );
    const qs = new URLSearchParams({ account_id: getAccountId(), ...filtered });
    return `${config.apiUrl}/${path}?${qs}`;
};

const parseErrorMessage = async (res, fallback) => {
    let msg = fallback;
    try {
        const j = await res.json();
        msg = j?.error || j?.message || msg;
    } catch { }
    return msg;
};

const postJson = async (path, body) => {
    const res = await fetch(`${config.apiUrl}/${path}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ account_id: getAccountId(), ...body }),
    });
    if (!res.ok) {
        const msg = await parseErrorMessage(res, `HTTP ${res.status}`);
        throw new Error(msg);
    }
    return res.json();
};

const putJson = async (path, body) => {
    const res = await fetch(`${config.apiUrl}/${path}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ account_id: getAccountId(), ...body }),
    });
    if (!res.ok) {
        const msg = await parseErrorMessage(res, `HTTP ${res.status}`);
        throw new Error(msg);
    }
    return res.json();
};

const del = async (path, params) => {
    const res = await fetch(buildUrl(path, params), { method: "DELETE" });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return res.json();
};

const get = async (path, params = {}) => {
    const res = await fetch(buildUrl(path, params));
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return res.json();
};

/* ════════════════════════════════════════════════════════════════
   PURCHASE ORDER
   ════════════════════════════════════════════════════════════════ */
export const getPurchaseOrders = (p = {}) => get("getPurchaseOrders", p);
export const getApprovedPurchaseOrderMaterialQuantities = () => get("getApprovedPurchaseOrderMaterialQuantities");
export const getPurchaseOrderKpis = () => get("getPurchaseOrderKpis");
export const getPurchaseOrderById = (id) => get("getPurchaseOrderById", { id });
export const createPurchaseOrder = (data) => postJson("createPurchaseOrder", data);
export const updatePurchaseOrder = (id, data) => putJson("updatePurchaseOrder", { id, ...data });
export const deletePurchaseOrder = (id) => del("deletePurchaseOrder", { id });
export const getPurchaseApprovals = (p = {}) => get("getPurchaseOrders", { ...p, pageSize: 1500 });
export const approvePurchaseOrder = (id) => putJson("updatePurchaseOrder", { id, status: "Approved" });
export const rejectPurchaseOrder = (id, rejectionReason) => putJson("updatePurchaseOrder", { id, status: "Rejected", rejectionReason });

/* ════════════════════════════════════════════════════════════════
   PURCHASE INVOICE
   ════════════════════════════════════════════════════════════════ */
export const getPurchaseInvoices = (p = {}) => get("getPurchaseInvoices", p);
export const getPurchaseInvoiceById = (id) => get("getPurchaseInvoiceById", { id });
export const createPurchaseInvoice = (data) => postJson("createPurchaseInvoice", data);
export const updatePurchaseInvoice = (id, data) => putJson("updatePurchaseInvoice", { id, ...data });
export const deletePurchaseInvoice = (id) => del("deletePurchaseInvoice", { id });
export const getDirectPurchaseInvoices = (p = {}) => get("getPurchaseInvoices", { ...p, piType: "Direct" });
export const getIndirectPurchaseInvoices = (p = {}) => get("getPurchaseInvoices", { ...p, piType: "Indirect" });
export const getDirectPIKpis = () => get("getPurchaseInvoiceKpis", { piType: "Direct" });
export const getIndirectPIKpis = () => get("getPurchaseInvoiceKpis", { piType: "Indirect" });